<template>
  <div class="inline-flex minw80" v-if="tagShow.length>0">
    <img v-for="(item,index) in tagShow" :key="index" class="w80 inline-flex pr10" :class="needTop ? (len>1 ? 'mt10' : 'mt8') : 'mt8'" :src="getImageUrl(item.image ? item.image : '')"/>
  </div>
</template>

<script>
export default{
  name:"goodsNameTag",
  props:{
    tagList:{
      type:Array,
      default(){
        return [];
      },
    },
    // 标签展示个数
    len:{
      type:Number,
      default:0,
    },
    needTop:{
      type:Boolean,
      default:true,
    }
  },
  data(){
    return {
      tagShow:[],
    };
  },
  created() {
    if(this.tagList.length>0){
      this.tagShow = this.tagList.slice(0,this.len);
    }
  },
  methods:{

  },
}
</script>

<style scoped lang="scss">
@media screen and (min-width: 750px) and (max-width: 1250px){
  .w80{width: 5vw;height:1.375vw}
  .minw80{min-width: 5vw;}
}
@media screen and (max-width: 750px){
  .w80{width: 6.25vw;height:1.71875vw}
  .minw80{min-width: 6.25vw;}
}
</style>